import { useState } from "react";
import { Link } from "react-router-dom";
import { Card, SVG } from "ui";
import Breadcrumb, { BreadcrumbObject } from "ui/files/core/Breadcrumb";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { posts } from "assets/data/posts";
import { FeedPost, MessageCommunityModal, ProfileHeader } from "components";
import TodayRoundedIcon from "@mui/icons-material/TodayRounded"; // date
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded"; // active
import BlockRoundedIcon from "@mui/icons-material/BlockRounded"; // blocked
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded"; // deleted

import PublicRoundedIcon from "@mui/icons-material/PublicRounded"; // country
import LanguageRoundedIcon from "@mui/icons-material/LanguageRounded"; // language
import PhoneRoundedIcon from "@mui/icons-material/PhoneRounded"; // phone
import InsertLinkRoundedIcon from "@mui/icons-material/InsertLinkRounded"; // website
import MenuBookRoundedIcon from "@mui/icons-material/MenuBookRounded"; // topics
import SignalWifiStatusbar4BarRoundedIcon from "@mui/icons-material/SignalWifiStatusbar4BarRounded"; // online offline

import SendRoundedIcon from "@mui/icons-material/SendRounded";
import { usersListArray } from "assets/data/usersData";
import { subtopics } from "assets/data/topics";
import { languagesArray } from "assets/data/languages";

const userTopics = subtopics.slice(0, 5);
const userLangs = languagesArray.filter(
    (i) => i.name === "Arabic" || i.name === "English"
);

const Profile = () => {
    const breadcrumb: BreadcrumbObject[] = [
        {
            path: "/",
            text: "Main"
        },
        {
            path: "/users",
            text: "Users"
        }
    ];

    const [user, setGroup] = useState(usersListArray[0]);

    const handleBlock = () => {
        setGroup(() => ({ ...user, status: "blocked" }));
    };
    const handleDelete = () => {
        setGroup(() => ({ ...user, status: "deleted" }));
    };
    const handleRestore = () => {
        setGroup(() => ({ ...user, status: "active" }));
    };

    const [openModal, setOpenModal] = useState(false);

    const handleSendMsg = () => {
        setOpenModal(true);
    };

    return (
        <>
            <section className="w-full h-full flex flex-col relative">
                <div className="w-full h-full flex relative  overflow-auto">
                    <div className="w-full flex flex-col">
                        <div className="w-full text-center">
                            <Breadcrumb
                                breadcrumb={breadcrumb}
                                currentPath="Profile"
                            />
                        </div>

                        <div className="w-full justify-center items-start flex flex-wrap gap-5 py-10 px-10 ">
                            <div className="w-full flex items-center justify-between gap-2 ">
                                <Link
                                    to="/users"
                                    className="flex justify-start items-center gap-3"
                                >
                                    <SVG svg="arrow-left" size={18} />

                                    <span className="text-sm dark:text-white">
                                        Back to Users list
                                    </span>
                                </Link>

                                <div className={`my-drop-down relative w-fit`}>
                                    {/* <div> */}
                                    <MoreVertIcon
                                        fontSize="medium"
                                        className="my-drop-down-more-vertical dark:text-white"
                                    />
                                    {/* </div> */}
                                    <div
                                        className={`my-drop-down-div right bg-neutral-100 dark:bg-momeento-300 rounded`}
                                    >
                                        <ul>
                                            <li
                                                className={`my-drop-down-item dark:text-white rounded`}
                                                onClick={() => {
                                                    if (
                                                        user.status ===
                                                        "blocked"
                                                    ) {
                                                        handleRestore();
                                                    } else {
                                                        handleBlock();
                                                    }
                                                }}
                                            >
                                                {user.status === "blocked"
                                                    ? "Unblock"
                                                    : "Block"}
                                            </li>
                                            <li
                                                className={`my-drop-down-item dark:text-white rounded`}
                                                onClick={() => {
                                                    if (
                                                        user.status ===
                                                        "deleted"
                                                    ) {
                                                        handleRestore();
                                                    } else {
                                                        handleDelete();
                                                    }
                                                }}
                                            >
                                                {user.status === "deleted"
                                                    ? "Restore"
                                                    : "Delete"}
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <ProfileHeader user={user} />
                            <div className="w-full flex flex-col lg:flex-row-reverse gap-10 justify-center items-start">
                                <div className="pt-10 pb-0 lg:pb-10 w-full lg:w-1/3">
                                    <Card style={{ borderRadius: "0.75rem" }}>
                                        <h2 className="font-bold text-lg dark:text-white">
                                            About
                                        </h2>
                                        <ul className="w-full flex flex-col justify-start items-start gap-3 dark:text-white">
                                            {/* followers */}
                                            <li className="w-full flex justify-start items-center gap-2">
                                                <SVG
                                                    svg="user-double-check"
                                                    className="cursor-default"
                                                />
                                                <Link
                                                    to={`/users/view/${user.id}/followers`}
                                                >
                                                    <span className="text-md font-semibold">
                                                        Followers:
                                                    </span>{" "}
                                                    5
                                                </Link>
                                            </li>
                                            {/* following */}
                                            <li className="w-full flex justify-start items-center gap-2">
                                                <SVG
                                                    svg="user-check"
                                                    className="cursor-default"
                                                />
                                                <Link
                                                    to={`/users/view/${user.id}/following`}
                                                >
                                                    <span className="text-md font-semibold">
                                                        Following:
                                                    </span>{" "}
                                                    25
                                                </Link>
                                            </li>

                                            {/* online - offline */}
                                            <li className="w-full flex justify-start items-center gap-2">
                                                <SignalWifiStatusbar4BarRoundedIcon fontSize="small" />
                                                <span className="text-md font-semibold">
                                                    Offline
                                                </span>
                                            </li>

                                            {/* status */}
                                            <li
                                                className={`w-full flex justify-start items-center gap-2 ${user.status !== "active" && "text-red-500"}`}
                                            >
                                                {user.status === "active" && (
                                                    <CheckCircleOutlineRoundedIcon fontSize="small" />
                                                )}
                                                {user.status === "blocked" && (
                                                    <BlockRoundedIcon fontSize="small" />
                                                )}
                                                {user.status === "deleted" && (
                                                    <DeleteRoundedIcon fontSize="small" />
                                                )}
                                                <div>
                                                    {user.status === "active"
                                                        ? "Active"
                                                        : user.status ===
                                                            "blocked"
                                                          ? "Blocked"
                                                          : "Deleted"}
                                                </div>
                                            </li>

                                            {/* languages */}
                                            <li className="w-full flex justify-start items-center gap-2">
                                                <LanguageRoundedIcon fontSize="small" />
                                                <div>
                                                    <h4 className="pb-1 text-md font-semibold">
                                                        Languages
                                                    </h4>
                                                    <div className="flex w-full justify-start items-center gap-1 flex-wrap">
                                                        {userLangs.map((i) => (
                                                            <div
                                                                className="rounded-lg px-2 bg-momeento-50 text-white"
                                                                key={i.code}
                                                            >
                                                                {i.name}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </li>

                                            {/* topics */}
                                            <li className="w-full flex justify-start items-center gap-2">
                                                <MenuBookRoundedIcon fontSize="small" />
                                                <div>
                                                    <h4 className="pb-1 text-md font-semibold">
                                                        Topics
                                                    </h4>
                                                    <div className="flex w-full justify-start items-center gap-1 flex-wrap">
                                                        {userTopics.map((i) => (
                                                            <div
                                                                className="rounded-lg px-2 bg-momeento-50 text-white"
                                                                key={
                                                                    i.SubTopicId
                                                                }
                                                            >
                                                                {i.Name}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </li>

                                            {/* Phone Number */}
                                            <li className="w-full flex justify-start items-center gap-2">
                                                <PhoneRoundedIcon fontSize="small" />
                                                <div>
                                                    <h4 className="pb-1 text-md font-semibold">
                                                        Phone Number
                                                    </h4>
                                                    <p>+918320416903</p>
                                                </div>
                                            </li>

                                            {/* website */}
                                            <li className="w-full flex justify-start items-center gap-2">
                                                <InsertLinkRoundedIcon fontSize="small" />
                                                <Link
                                                    to="#"
                                                    className="text-md font-semibold"
                                                >
                                                    Website
                                                </Link>
                                            </li>

                                            {/* date of birth */}
                                            <li className="w-full flex justify-start items-center gap-2">
                                                <TodayRoundedIcon fontSize="small" />
                                                <div>
                                                    <h4 className="pb-1 text-md font-semibold">
                                                        Date of Birth
                                                    </h4>
                                                    <p>Dec 30, 1998</p>
                                                </div>
                                            </li>

                                            {/* country */}
                                            <li className="w-full flex justify-start items-center gap-2">
                                                <PublicRoundedIcon fontSize="small" />
                                                <div>
                                                    <h4 className="pb-1 text-md font-semibold">
                                                        Country
                                                    </h4>
                                                    <p>India</p>
                                                </div>
                                            </li>

                                            <li className="w-full flex justify-start items-center gap-2">
                                                <SendRoundedIcon fontSize="small" />
                                                <button
                                                    className="pb-1 text-md font-semibold"
                                                    onClick={handleSendMsg}
                                                >
                                                    send message
                                                </button>
                                            </li>
                                        </ul>
                                    </Card>
                                </div>

                                <div className="community-posts pt-0 lg:pt-10 pb-10 w-full lg:w-2/3">
                                    {posts.map((post) => (
                                        <FeedPost post={post} key={post.id} />
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <MessageCommunityModal
                open={openModal}
                setOpen={setOpenModal}
                user={user}
            />
        </>
    );
};

export default Profile;
